export default __webpack_public_path__ + "static/media/logo-ttivos-png.e7551c18.png";